module.exports = __webpack_public_path__ + "static/mockupweb-1@2x-1b07b4a9cabde5daf264fb89e0078e15.png";